/**
 * Created by Ivan on 25.05.2025
 */

const WildCardTutorial = function () {
    return new TutorialScenario(WildCardTutorial.NAME, {
        listSteps: () => [
            WildCardTutorial.createClickWildCardStep(),
            TileGameTutorialHelper.createPlayCardStep(WildCardTutorial.CONFIG.tutorial[1])
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(WildCardTutorial.NAME);
            Game.currentGame.hand.setCards(WildCardTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(WildCardTutorial.NAME)
    });
};

WildCardTutorial.createClickWildCardStep = () => new TutorialStep({
    onStart: function () {
        Game.currentGame.wildcardBooster.activateTutorial();
        const target = cleverapps.Scenes.GetSceneComponent(TriPeaksSceneComponent).wildCardButton;

        cleverapps.focusManager.showControlsWhileFocused(["hint_4"]);

        this.force = TileGameTutorialHelper.createForce(target, WildCardTutorial.CONFIG.tutorial[0]);

        cleverapps.tutorial.on("shiftWildcard", this.finish.bind(this), this);
    },

    onFinish: function () {
        this.force.hideForceHints();
    }
});

WildCardTutorial.NAME = "wildCard";
WildCardTutorial.CONFIG = {
    handValues: ["8"],
    tutorial: [{
        force: "WildCardTutorialMessage",
        type: WildCardTutorial.NAME
    }, {
        force: ""
    }]
};
